export default "__VITE_ASSET__35Xtw3ff__"